import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const LazyReportSectionLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-reportsection" */ "./ReportSection")).then((bundle)=>{
        return {
            default: bundle.ReportSection
        };
    });
export const LazyReportSection = /*#__PURE__*/ lazy(LazyReportSectionLazyLoader);
